<template>
  <div
    class="mt-3"
    style="width: 100%;overflow: auto"
  >
    <v-item-group
      v-model="color"
      class="d-flex"
    >
      <v-item
        v-for="(color, i) in colors"
        :key="i"
        v-slot="{ active, toggle }"
        :value="color"
        class="me-3"
      >
        <div
          @click="toggle"
          class="d-flex"
          style="width: 50px;border-radius: 10px"
          :style="{'border' : (active ? '3px solid rgb(0 99 255)' : '')}"
        >
          <div
            style="width: 25px;height: 50px;border-top-right-radius: 10px;border-bottom-right-radius: 10px"
            :style="{'background':color.color1}"
          ></div>
          <div
            style="width: 25px;height: 50px"
            :style="{'background':color.color3}"
          ></div>
          <div
            style="width: 25px;height: 50px"
            :style="{'background':color.color2}"
          ></div>
          <div
            style="width: 25px;height: 50px;border-top-left-radius: 10px;border-bottom-left-radius: 10px"
            :style="{'background':color.color4}"
          ></div>
        </div>
      </v-item>
    </v-item-group>
  </div>
</template>

<script>
  export default {
    name: 'PrintTemplateSelector',
    components: {
    },
    data: () => ({
      colors: [],
      color: null,
    }),
    watch: {
      color (val) {
        this.$emit('input', val)
        localStorage.setItem('invoicePrintColor', JSON.stringify(val))
      },
    },
    activated () {
    },
    beforeMount () {
      this.colors = [
        {
          name: 'color1',
          color1: '#023047',
          color2: '#FFB703',
          color3: '#0066FF',
          color4: '#0242a1',
          color5: '#FB8500',
        },
        {
          name: 'color2',
          color1: '#172640',
          color2: '#FFC142',
          color3: '#00BBB3',
          color4: '#00857F',
          color5: '#C49533',
        },
        {
          name: 'color3',
          color1: '#F1FAEE',
          color2: '#E63946',
          color3: '#457B9D',
          color4: '#234e69',
          color5: '#b61521',
        },
        {
          name: 'color4',
          color1: '#1f306e',
          color2: '#553772',
          color3: '#8f3b76',
          color4: '#c7417b',
          color5: '#f5487f',
        },
        {
          name: 'color5',
          color1: '#fff29c',
          color2: '#492b7c',
          color3: '#f6d912',
          color4: '#ed8a0a',
          color5: '#301551',
        },
        {
          name: 'color6',
          color1: '#ffca7a',
          color2: '#f7a325',
          color3: '#12492f',
          color4: '#0a2f35',
          color5: '#f56038',
        },
        {
          name: 'color7',
          color1: '#dadada',
          color2: '#bbbbbb',
          color3: '#e1e1e1',
          color4: '#b6b6b6',
          color5: '#b2b1b0',
        },
      ]
      var color = localStorage.getItem('invoicePrintColor')
      if (color && color !== 'undefined') {
        this.color = JSON.parse(color)
      }
    },
    mounted () {
    },
    methods: {
    },
  }
</script>

<style scoped>

</style>
